import React from "react";
import { useLang } from "../context/LangContext";
import PageHeader from "../components/site/PageHeader";
import { IMG } from "../lib/siteData";
import { Lock, ArrowRight, FileSpreadsheet } from "lucide-react";
import { Link } from "react-router-dom";

const Projects = () => {
  const { t } = useLang();
  return (
    <div data-testid="projects-page">
      <PageHeader
        eyebrow={t("nav.projects")}
        title="Project References"
        subtitle="Waves Technology FZCO supports industrial, water treatment and infrastructure projects through engineering coordination, procurement support, technology selection and project development services across the Middle East."
        image={IMG.processPlant}
      />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="bg-steel-50 border border-steel-200 p-10 lg:p-14 text-center" data-testid="references-on-request">
            <Lock className="w-12 h-12 text-brand mx-auto mb-6" strokeWidth={1.4} />
            <div className="overline mb-3">Project References</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-ink mb-5 leading-tight">
              Project References Available Upon Request
            </h2>
            <p className="text-ink-muted text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
              Specific project details, capacities, locations, contract values and client identities are not published on this website. Detailed references and case material can be shared on request, subject to client confidentiality requirements.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/contact" data-testid="references-contact-cta" className="inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white px-7 py-4 font-semibold text-sm uppercase tracking-[0.18em] transition-colors">
                Request References <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/rfq" className="inline-flex items-center gap-2 border-2 border-ink hover:bg-ink hover:text-white text-ink px-7 py-4 font-semibold text-sm uppercase tracking-[0.18em] transition-colors">
                Submit RFQ <FileSpreadsheet className="w-4 h-4" />
              </Link>
            </div>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-steel-200 border border-steel-200">
            {[
              { title: "Engineering Coordination", desc: "Process, mechanical, electrical and I&C engineering coordination for industrial and water projects." },
              { title: "Procurement Support", desc: "International sourcing, vendor coordination and procurement support for industrial scopes." },
              { title: "Project Development", desc: "Concept, feasibility, technology selection and budgetary support for new investments." },
            ].map((card, i) => (
              <div key={card.title} className="bg-white p-7 indicator-line" data-testid={`experience-area-${i}`}>
                <span className="num-tag block mb-3">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-heading font-bold text-lg text-ink mb-3">{card.title}</h3>
                <p className="text-sm text-ink-muted leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
